/**
 * Table configuration persistence — saves column visibility and order to localStorage.
 */

export interface TableConfig {
  hiddenKeys: string[];
  columnOrder: string[];
}

export function loadTableConfig(tableId: string): TableConfig | undefined {
  try {
    const raw = localStorage.getItem(`hubble-table-${tableId}`);
    if (!raw) return undefined;
    return JSON.parse(raw) as TableConfig;
  } catch {
    return undefined;
  }
}

export function saveTableConfig(tableId: string, config: TableConfig) {
  localStorage.setItem(`hubble-table-${tableId}`, JSON.stringify(config));
}
